import * as React from "react";

const CartIcon = ({ count = 0, size = 50, variant = "standard" }) => {
  const isDesktop = variant === "desktop-header";

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        backgroundColor: isDesktop ? "#333" : "#e31e24",
        borderRadius: isDesktop ? "12px" : "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Cart SVG */}
      <svg
        width={size * 0.5}
        height={size * 0.5}
        viewBox="0 0 24 24"
        fill="white"
      >
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 
        0c-1.1 0-1.99.9-1.99 2S15.9 22 17 22s2-.9 
        2-2-.9-2-2-2zM7.16 14h9.45c.75 0 1.41-.41 
        1.75-1.03l3.58-6.49a1 1 0 0 0-.87-1.48H5.21L4.27 
        3H1v2h2l3.6 7.59-1.35 2.44C4.52 16.37 5.48 18 
        7 18h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L7.16 14z" />
      </svg>

      {/* Badge */}
      {count > 0 && (
        <div
          style={{
            position: "absolute",
            top: "-2px",
            right: "-2px",
            backgroundColor: "#000",
            color: "#fff",
            borderRadius: "50%",
            width: size * 0.42,
            height: size * 0.42,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: size * 0.28,
            fontWeight: 800,
            border: isDesktop ? `2px solid #333` : "2px solid #e31e24",
            boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
          }}
        >
          {count}
        </div>
      )}
    </div>
  );
};

export default CartIcon;
